import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ArrowLeft, Star } from "lucide-react";
import Header from "./Header";
import Footer from "./Footer";
import Testimonials from "./Testimonials";
import FloatingActions from "./FloatingActions";
import CookieBanner from "./CookieBanner";
import { contactInfo } from "../mock";

const ReferenzenPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Referenzen & Bewertungen | MAG Facility Services UG – Augsburg";
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute("content", "Referenzen & Kundenbewertungen von MAG Facility Services UG aus Augsburg. Erfahren Sie, was unsere Kunden über unsere Gebäudereinigung sagen.");
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", "https://www.mag-facilityservices.de/referenzen");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));

    return () => {
      document.title = "MAG Facility Services UG | Gebäudereinigung Augsburg";
      if (canonical) canonical.setAttribute("href", "https://www.mag-facilityservices.de/");
      observer.disconnect();
    };
  }, []);

  return (
    <>
      <Header />
      <main>
        {/* Intro */}
        <section className="relative pt-[74px] bg-white overflow-hidden">
          <div className="pointer-events-none absolute inset-0 -z-10">
            <div className="absolute -top-40 left-0 w-[720px] h-[720px] rounded-full bg-blue-100/60 blur-3xl" />
          </div>
          <div className="relative max-w-5xl mx-auto px-5 sm:px-8 py-14 lg:py-20">
            <Link to="/" className="inline-flex items-center gap-2 text-[14px] font-medium text-slate-600 hover:text-blue-600 transition-colors">
              <ArrowLeft className="w-4 h-4" /> Zur Startseite
            </Link>
            <span className="mt-8 block text-[13px] font-bold tracking-[0.22em] text-blue-600 uppercase">
              Referenzen
            </span>
            <h1 className="font-display mt-3 text-slate-900 text-[34px] sm:text-[50px] leading-[1.05] tracking-tight" style={{ fontWeight: 800 }}>
              Das sagen unsere Kunden
            </h1>
            <div className="mt-4 flex items-center gap-3">
              <div className="flex gap-0.5">
                {Array.from({ length: 5 }).map((_, k) => (
                  <Star key={k} className="w-5 h-5 text-amber-400 fill-amber-400" />
                ))}
              </div>
              <span className="text-[15px] font-semibold text-slate-700">5,0 / 5,0 – von unseren Kunden bestens bewertet</span>
            </div>
            <p className="mt-4 text-[17px] text-slate-600 max-w-2xl leading-relaxed">
              Zufriedene Kunden sind unser bester Beweis. Ob Büros, Praxen, Hausverwaltungen oder Gewerbebetriebe in Augsburg und Umgebung – hier erfahren Sie, warum unsere Kunden auf MAG Facility Services setzen.
            </p>
          </div>
        </section>

        {/* Reused Testimonials */}
        <Testimonials />

        {/* CTA */}
        <section className="py-16 bg-white">
          <div className="max-w-4xl mx-auto px-5 sm:px-8">
            <div className="rounded-3xl bg-slate-900 px-8 py-12 lg:px-14 text-center">
              <h2 className="font-display text-white text-[26px] sm:text-[34px]" style={{ fontWeight: 800 }}>
                Werden Sie unser nächster zufriedener Kunde
              </h2>
              <p className="mt-3 text-slate-300 text-[16px] max-w-xl mx-auto">
                Überzeugen Sie sich selbst von unserer Qualität – fordern Sie ein kostenloses Angebot an.
              </p>
              <div className="mt-7 flex flex-col sm:flex-row gap-3 justify-center">
                <a href="/#kontakt" className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-lg bg-blue-600 text-white font-semibold hover:bg-blue-700 transition-colors">
                  Kostenloses Angebot anfordern <ArrowRight className="w-4 h-4" />
                </a>
                <a href={contactInfo.phoneHref} className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-lg bg-white/10 text-white font-semibold hover:bg-white/20 transition-colors">
                  {contactInfo.phone}
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <FloatingActions />
      <CookieBanner />
    </>
  );
};

export default ReferenzenPage;
